import 'regenerator-runtime/runtime';
import 'antd/dist/antd.less';
import '/app/src/global.less';
import React from 'react';
import ReactDOM from 'react-dom';
import { renderClient } from '@umijs/renderer-react';
import { history } from './core/history';
import { routes } from './core/routes';
import { applyRuntimePlugins, getInitialState, onRouteChange, plugins } from './core/plugin';


function showFatal(e) {
  console.error('[umi] fatal', e);
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML =
      '<pre style="color:#b00;padding:16px;white-space:pre-wrap;font:12px/1.4 monospace;">' +
      String((e && e.stack) || e) +
      '</pre>';
  }
}

class BootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error) {
    console.error('[umi] render error', error);
  }
  render() {
    if (this.state.error) {
      return React.createElement(
        'pre',
        { style: { color: '#b00', padding: 16, whiteSpace: 'pre-wrap', font: '12px/1.4 monospace' } },
        String((this.state.error && this.state.error.stack) || this.state.error),
      );
    }
    return this.props.children;
  }
}

async function bootstrap() {
  const root = document.getElementById('root');
  let initialState;
  try {
    initialState = await getInitialState();
  } catch (e) {
    console.error('[umi] getInitialState error', e);
  }

  const doRender = () => {
    const element = renderClient({
      routes,
      history,
      plugin: { applyRuntimePlugins, onRouteChange, plugins },
      initialState,
    });
    const app = applyRuntimePlugins({ element, routes, history, initialState });
    ReactDOM.render(React.createElement(BootErrorBoundary, null, app), root);
  };

  const appPlugin = plugins && plugins[0];
  if (appPlugin && typeof appPlugin.render === 'function') {
    appPlugin.render(doRender);
  } else {
    doRender();
  }
}

bootstrap().catch(showFatal);

